var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0402 58.8597C71.0402 63.0597 72.2352 64.7347 75.3602 64.7347C82.3252 64.7347 86.7602 55.8597 86.7602 41.0997C86.7602 18.5397 70.3202 7.73969 49.7952 7.73969C28.6802 7.73969 9.47523 21.8997 9.47523 48.6597C9.47523 74.2197 26.2752 88.1397 52.0752 88.1397C60.8352 88.1397 66.7152 87.1797 75.7102 84.1797L77.6402 92.2147C68.7602 95.0997 59.2702 95.9347 51.9552 95.9347C18.1152 95.9347 -0.00976562 77.3347 -0.00976562 48.6547C-0.00976562 19.7347 20.9952 0.0546875 49.9152 0.0546875C80.0352 0.0546875 95.9902 18.0547 95.9902 40.1347C95.9902 58.8547 90.1152 73.1347 71.6352 73.1347C63.2302 73.1347 57.7152 69.7747 56.9952 62.3297C54.8352 70.6097 49.0752 73.1347 41.2702 73.1347C30.8302 73.1347 22.0702 65.0897 22.0702 48.8947C22.0702 32.5747 29.7552 22.4947 43.5552 22.4947C50.8752 22.4947 55.4352 25.3747 57.4652 29.9347L60.9502 23.5747H71.0302V58.8597H71.0402ZM56.2852 43.0197C56.2852 36.4247 51.3602 33.6597 47.2802 33.6597C42.8402 33.6597 37.9252 37.2547 37.9252 47.8197C37.9252 56.2197 41.6452 60.8997 47.2802 60.8997C51.2402 60.8997 56.2852 58.3797 56.2852 51.4197V43.0197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.19cde657dfc1976633dd45c40aea1229.svg";
export { ForwardRef as ReactComponent };